import { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useDeleteSeries = () => {
    const navigate = useNavigate()
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const clickEvent = () => {
        fetchRequest("DELETE", `/admin/series/${idx}`)
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                navigate(-1)
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("대회 시리즈 데이터가 존재하지 않습니다.")
                break
        }
    }, [fetchResult])

    return [clickEvent]
}

export default useDeleteSeries